// extracted by mini-css-extract-plugin
module.exports = {"description":"AddIssueLayout_description__8oQF6","highPriorityCheckbox":"AddIssueLayout_highPriorityCheckbox__2RXcc"};